/**
 * Per-route SEO + structured-data helper.
 * Uses React 19 native document metadata hoisting:
 *   https://react.dev/reference/react-dom/components/title
 *
 * Renders <title>, <meta>, <link rel="canonical">, OpenGraph, Twitter cards,
 * and JSON-LD structured data. All of these get hoisted into <head> by React
 * and are captured by the build-time prerenderer (scripts/prerender.js) into
 * each route's static HTML file — so Google/Bing/LinkedIn/Twitter crawlers
 * see fully-populated metadata on first request, no JS execution required.
 */
const SITE_URL = "https://www.abhilash.com";
const DEFAULT_OG_IMAGE = "https://www.abhilash.com/og-image.png";

const SeoHead = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
  type = "website",
  jsonLd = null,
  keywords = "",
}) => {
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* OpenGraph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Abhilash Puljal" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </>
  );
};

export default SeoHead;
